import styled from "styled-components";
import { customScrollbar } from "../styles/scrollbar";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  height: 100%;
  overflow: hidden;
`;

export const ChatInputWrapper = styled.div`
  background-color: white;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
`

export const QuickActionsPanelWrapper = styled.div`
  position: relative;
  z-index: 2;
  pointer-events: none;
  height: 0;
`

export const InfoBanner = styled.div`
  background-color: var(--background-primary-canvas);
  border: 1px solid var(--border-primary-subtle);
  color: var(--primary);
  padding: 4px 8px;
  margin: 0 12px 6px 12px;
  border-radius: 3px;
  font-size: 11px;
  line-height: 1.3;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StyledLink = styled.a`
  color: var(--primary);
  text-decoration: underline;

  &:hover {
    color: var(--background-primary-hover);
  }
`;

export const BookmarkButton = styled.button`
  background-color: var(--primary);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 2px 6px;
  margin: 0 2px;
  cursor: pointer;
  font-size: 12px;
  display: inline-block;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--background-primary-hover);
  }
`;

export const StyledUl = styled.ul`
  margin: 0.5em 0;
  padding-left: 1.5em;
  list-style-type: disc;
  list-style-position: outside;
`;

export const StyledOl = styled.ol`
  margin: 0.5em 0;
  padding-left: 2.5em;
  list-style-type: decimal;
  list-style-position: outside;
`;

export const StyledLi = styled.li`
  margin: 0.25em 0;
  display: list-item;
  list-style-position: outside;
`;

export const TableScrollBox = styled.div`
  overflow: auto;
  max-height: 60vh;
  isolation: isolate;
  margin: 16px 0;
  ${customScrollbar}
`;
